export const SWAG_51_LOCAL_STORAGE_KEY = "mb-swag-51";
export const SWAG_LINK = "https://metaba.se/51-beta-swag";
